import React, { useEffect, useState } from "react";
import Sidebar from "../Sidebars/Sidebar";
import { Layout } from "antd";
import "./style.css";
import SidebarAdmin from "../Sidebars/SidebarAdmin";
import SidebarCompany from "../Sidebars/SidebarCompany";
import { useLocation } from "react-router-dom";
import PageLayout from "../../Components/PageLayout";

const { Content } = Layout;

const AppLayout = ({ setFlag, userType, contents }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [pageName, setPageName] = useState("General");
  const path = useLocation();
  const locationPath = path.pathname;

  useEffect(() => {
    if (locationPath.includes("/general")) {
      setPageName("General");
    } else if (locationPath.includes("/fuel-efficiency")) {
      setPageName("Fuel Efficiency");
    } else if (locationPath.includes("/fuel")) {
      setPageName("Fuel");
    } else if (locationPath.includes("/security")) {
      setPageName("Security");
    } else if (locationPath.includes("/stations")) {
      setPageName("Fuel Stations");
    } else if (locationPath.includes("/companies")) {
      setPageName("Companies");
    } else if (locationPath.includes("/dashboard")) {
      setPageName("Dashboard");
    } else if (locationPath.includes("/mileage")) {
      setPageName("Mileage");
    } else if (locationPath.includes("/idle")) {
      setPageName("Idle");
    } else if (locationPath.includes("/decision-engine")) {
      setPageName("Decision Engine");
    } else if (locationPath.includes("/sensor")) {
      setPageName("Sensor");
    } else if (locationPath.includes("/servicing-reminder")) {
      setPageName("Servicing & Reminder");
    } else if (locationPath.includes("/more-analysis")) {
      setPageName("More Analysis");
    } else if (locationPath.includes("/settings")) {
      setPageName("Settings");
    }
  }, [locationPath]);

  // Handle screen size check
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      setCollapsed(window.innerWidth < 768);
    };

    handleResize(); // run once on mount
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Determine layout margin class
  const layoutMarginClass =
    isMobile || collapsed ? "margin-collapsed" : "margin-expanded";

  return (
    <div className="app-layout">
      <Layout style={{ minHeight: "100vh" }}>
        {userType === "user" ? (
          <>
            <Sidebar
              breakpoint="md"
              collapsed={collapsed}
              setCollapsed={setCollapsed}
              setFlag={setFlag}
            />
          </>
        ) : userType === "company" ? (
          <>
            <SidebarCompany
              breakpoint="md"
              collapsed={collapsed}
              setCollapsed={setCollapsed}
            />
          </>
        ) : (
          <>
            <SidebarAdmin
              breakpoint="md"
              collapsed={collapsed}
              setCollapsed={setCollapsed}
            />
          </>
        )}
        <Layout className={`site-layout ${layoutMarginClass}`}>
          <Content className="content">
            <PageLayout
              pageName={pageName}
              collapsed={collapsed}
              setCollapsed={setCollapsed}
            >
              {contents}
            </PageLayout>
          </Content>
        </Layout>
      </Layout>
    </div>
  );
};

export default AppLayout;
